import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=26107a0b&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26107a0b')) {
      api.createRecord('26107a0b', component.options)
    } else {
      api.reload('26107a0b', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=26107a0b&", function () {
      api.rerender('26107a0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sN1jSJLlG1Wi/JS/videoIframe.vue"
export default component.exports